import { t } from "@lingui/macro";
import { GithubLogo, GoogleLogo } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";

import { stashSelectedPlanFromSearch } from "@/client/libs/selected-plan";
import { useAuthProviders } from "@/client/services/auth/providers";

export const SocialAuth = () => {
  const { providers } = useAuthProviders();

  if (!providers || providers.length === 0) return null;

  const persistSelectedPlan = () => {
    stashSelectedPlanFromSearch();
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      {providers.includes("github") && (
        <Button asChild size="lg" className="w-full !bg-[#222] !text-white hover:!bg-[#222]/80">
          <a href="/api/auth/github" onClick={persistSelectedPlan}>
            <GithubLogo className="mr-3 h-4 w-4" />
            {t`GitHub`}
          </a>
        </Button>
      )}
      {providers.includes("google") && (
        <Button
          asChild
          size="lg"
          className="w-full !bg-[#4285F4] !text-white hover:!bg-[#4285F4]/80"
        >
          <a href="/api/auth/google" onClick={persistSelectedPlan}>
            <GoogleLogo className="mr-3 h-4 w-4" />
            {t`Google`}
          </a>
        </Button>
      )}
    </div>
  );
};
